<mat-nav-list>
   <a mat-list-item *ngFor="let link of links" (click)="link.clickHandler(); onOpenLink($event);">
      <span mat-line>{{link.title}}</span>
   </a>
</mat-nav-list>